import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    estavel: {
        backgroundColor: theme.palette.success.main,
    },
    beta: {
        backgroundColor: theme.palette.info.main,
    },
    alfa: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.warning.contrastText
    },
    dataLog: {
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(.3, 1),
        '& span': {
            color: theme.palette.common.white,
            fontSize: '.7rem'
        }
    },
}))